import { createApp } from 'vue'
import WordCounter from './WordCounter.vue'
import './assets/global.css'

createApp(WordCounter).mount('#word-counter')
